<script>
    import { createEventDispatcher } from 'svelte';
    import { afterUpdate, onMount } from 'svelte';

    export let text;
    export let next_status;
    export let prev_status;

    const dispatch = createEventDispatcher();

    function prev() {
        dispatch('prev');
    }

    function next() {
        dispatch('next');
    }

    let prev_class = "";
    let next_class = "";

    afterUpdate(() => {
        text = text;
        next_class = "";
        prev_class = "";
        
        if(!next_status){
            next_class = "inactive";
        }
        if(!prev_status){
            prev_class = "inactive";
        }
    });
</script>

<div class="day-switcher">
    <div class="prev {prev_class}" on:click={prev}><img src="img/icons/chevron-left-solid.svg" alt="Back" /></div>
    <div class="date">{text}</div>
    <div class="next {next_class}" on:click={next}><img src="img/icons/chevron-right-solid.svg" alt="Next" /></div>
</div>

<style>
.day-switcher{
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
}
.prev, .next{
    position: relative;
    background: #fff;
    color: #000;
    font-size: 1.4rem;
    width: 45px;
    height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid var(--darker-medium-color);

    border-radius: 2px;
}
.prev.inactive, .next.inactive{
    border: none;
    background: none;
}

.prev img, .next img{
    width: 10px;
    height: auto;
}
.date{
    font-family: 'futura-pt', Arial;
    font-weight: 700;
    font-size: 1.0rem;
    background: #fff;
    color: #000;
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    border: 1px solid var(--darker-medium-color);
    height: 30px;
    box-sizing: border-box;
    margin-left: 5px;
    margin-right: 5px;

    border-radius: 2px;
}
</style>